import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { AutoLogoutService } from './core/common/services/auto-logout.service';
import { PendingTaskInwardService } from './core/common/services/pending-inward.service';
import { AuthService } from './core/auth/auth.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    userRole: string;

    /**
     * Constructor
     */
    constructor(private autoLogoutService: AutoLogoutService,
        private pendingTaskInwardService: PendingTaskInwardService,
        private _authService: AuthService) {

    }

    ngOnInit() {
        this.autoLogoutService.startMonitoring();
        this.userRole = this._authService.getRolesFromToken();

        if (!this.isAdminRole()) {
            this.pendingTaskInwardService.start();
        }
    }

    ngOnDestroy() {
        this.autoLogoutService.stopMonitoring();
    }

    private isAdminRole(): boolean {
        return ['Admin', 'MasterAdmin', 'SuperAdmin'].includes(this.userRole);
    }
}
